<template>
  <div
    class="bbp-percent-complete"
    :class="[isError && 'bbp-percent-complete_error']"
    :ref="`bbp-percent-complete_${row._id}`"
    @click="onShowPopup"
  >
    <div class="bbp-percent-complete__text">
      {{value}}
    </div>
    <div
      v-if="isError && 'bbp-percent-complete_error'"
      class="bbp-percent-complete__icon"
      v-html="infoIcon()"
      @mouseenter="onMouseenter($event)"
      @mouseleave="isShow = false"
    />
    <transition name="bbp-bounce">
      <div
        v-if="isShow"
        :style="popupStyle"
      >
        <BBPPopupInfo
          :text="errorInfo"
          :isTextDefault="true"
        />
      </div>
    </transition>
    <transition name="bbp-bounce">
      <BBPSelectList
        v-if="isShowSteps && items.length"
        :items="items"
        :settings="column.settings"
        :popupPosition="popupPosition"
        :isActive="isActive"
        @onActive="onActive"
      />
    </transition>
  </div>
</template>

<script>

import {get} from 'lodash'
import { INFORMATION_ICON } from '@/constants/icons'
import BBPPopupInfo from '@/components/Main/BBPPopups/BBPPopupInfo'
import BBPSelectList from '@/components/Main/BBPSelectList/BBPSelectList'

export default {
  name: 'BBPPercentComplete',
  components: {
    BBPSelectList,
    BBPPopupInfo
  },
  props: {
    column: {
      type: Object,
      default: () => ({})
    },
    row: {
      type: Object,
      default: () => ({})
    },
    hover: {
      type: String,
      default: ''
    }
  },
  data: () => ({
    infoIcon: INFORMATION_ICON,
    isShow: false,
    popupStyle: {},
    isShowSteps: false,
    popupPosition: {},
    isActive: ''
  }),
  computed: {
    isError () {
      const { typeServiceProject = {} } = this.row
      if (typeServiceProject === null) return this.$set(this.row, typeServiceProject, {})
      const { stepServiceProject = [] } = typeServiceProject
      return !typeServiceProject || !stepServiceProject.length
    },
    value () {
      const { prop } = this.column
      return get(this.row, prop, '')
    },
    errorInfo () {
      const { typeServiceProject } = this.row
      if (!typeServiceProject) return 'Service type not assigned'
      const { stepServiceProject = [] } = typeServiceProject
      if (!stepServiceProject.length) return 'No steps are assigned in the services'
    },
    items () {
      const { items } = this.column
      return get(this.row, items, [])
    },
    isNoClick () {
      const { isNoClick = false } = this.column
      return isNoClick
    }
  },
  methods: {
    onMouseenter ({ target }) {
      const { top, height, left, width } = target.getBoundingClientRect()
      this.popupStyle = {
        position: 'fixed',
        top: `${top + height + 8}px`,
        left: `${left + (width / 2)}px`
      }
      this.isShow = true
    },
    onShowPopup () {
      if (this.isNoClick) return
      const { innerHeight } = window
      const heightModal = 116
      const elem = this.$refs[`bbp-percent-complete_${this.row._id}`]
      const { top, height, left } = elem.getBoundingClientRect()
      const topDynamic = innerHeight < top + heightModal + height ? top - heightModal : top + height + 8
      this.popupPosition = {
        position: 'fixed',
        top: `${topDynamic}px`,
        left: `${left}px`
      }
      this.isShowSteps = true
    },
    onActive (item) {
      const { _id } = item
      this.isActive = _id
      const { defaultValue } = this.column
      this.row[defaultValue] = item

      const currentElement = {
        row: this.row,
        column: this.column,
        isUpdateStepServiceProject: true
      }
      this.$emit('updateProject', currentElement)
      this.isShowSteps = false
    },
    setDefaultActive () {
      const { defaultValue } = this.column
      const value = get(this.row, defaultValue, '')
      if (!value) return
      this.isActive = value._id
    }
  },
  watch: {
    hover () {
      this.isShowSteps = false
    }
  },
  beforeMount () {
    this.setDefaultActive()
  }
}
</script>

<style lang="scss" scoped>
@import '../../../../sass/variables';

  .bbp-percent-complete {
    display: flex;
    align-items: center;
    position: relative;
    grid-gap: 0 6px;
    cursor: pointer;

    &_error {
      color: $color-pomegranate
    }

    &__icon {
      display: flex;
      cursor: pointer;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Main/BBPTable/BBPPercentComplete/BBPPercentComplete.vue